import { supabase } from './client';
import { authService } from './auth';

export interface Profile {
  id: string;
  user_id: string;
  display_name: string;
  theme: string;
  created_at?: string;
}

export const profilesService = {
  async getProfiles() {
    const response = await authService.getUser();
    const user = response.user;
    if (!user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', user.id);

    if (error) throw error;
    return data as Profile[];
  },

  async createProfile(displayName: string, theme: string = 'default') {
    const response = await authService.getUser();
    const user = response.user;
    if (!user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('profiles')
      .insert({
        id: crypto.randomUUID(), // Generate ID manually to satisfy NOT NULL constraint
        user_id: user.id,
        display_name: displayName,
        theme
      })
      .select()
      .single();

    if (error) throw error;
    return data as Profile;
  },

  async updateProfile(id: string, updates: Partial<Profile>) {
    const response = await authService.getUser();
    const user = response.user;
    if (!user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('profiles')
      .update(updates)
      .eq('id', id)
      .eq('user_id', user.id)
      .select()
      .single();

    if (error) throw error;
    return data as Profile;
  },

  async deleteProfile(id: string) {
    const response = await authService.getUser();
    const user = response.user;
    if (!user) throw new Error('User not authenticated');

    const { error } = await supabase
      .from('profiles')
      .delete()
      .eq('id', id)
      .eq('user_id', user.id);

    if (error) throw error;
  }};

